import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

export const getCastRelationshipId = () => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_CAST_RELATIONSHIP_ID) ?? '';
};

export const hasCastRelationship = () => {
  return Boolean(getCastRelationshipId());
};
